import * as z from 'zod';
// Mirrors AddonsEmailSendTimeAnchor on the server
export const AddonsEmailAnchor = z.enum(['after_booking', 'before_check_in']);
/** En tidpunkt för tillvalsmejlet: ett antal hela timmar efter bokning eller före incheckning. */
export const AddonsEmailSendTime = z.object({
    anchor: AddonsEmailAnchor,
    offset_minutes: z.int()
});
/** Campingens schemalagda tillvalsmejl: om det skickas och när. */
export const AddonsEmailSettings = z.object({
    enabled: z.boolean(),
    send_times: z.array(AddonsEmailSendTime)
});
